import { makeStyles } from '@material-ui/core';
import logo from './answerrocket-logo.png';

const useStyles = makeStyles({
  img: {
    // Sized to the 56px rail: the mark is wider than it is tall, so height is
    // what has to give. maxWidth guards against it bleeding into the divider.
    height: 30,
    width: 'auto',
    maxWidth: 44,
    // Inversion is theme-dependent; see design-system.css. The collapsed rail
    // shows this mark.
  },
});

export const LogoIcon = () => {
  const classes = useStyles();
  return <img src={logo} alt="AnswerRocket" className={classes.img} />;
};
